import { NextError404ScreenProps } from '../types';

const useViewModel = (props: NextError404ScreenProps): NextError404ScreenProps => {
    return {
        ...props,
    };
};

export { useViewModel };
